import { extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { DisplayConfiguration } from './DisplayConfiguration.js';
import { pickDataAttributes } from '../../../utils/pickDataAttributes.js';
var styles = Object.freeze([{}, {}]);

var DisplayFlex360 = function DisplayFlex360(props) {
  var dataAttributes = pickDataAttributes(props, 'display-flex-360');
  return /*#__PURE__*/React.createElement(DisplayConfiguration, _extends({}, props, {
    styles: styles
  }, dataAttributes, {
    className: "display-flex-360"
  }));
};

DisplayFlex360.displayName = "DisplayFlex360";
export { DisplayFlex360 };